module.exports = __webpack_public_path__ + "img/BOC_bottom2.724becc5.jpg";